import { useState } from 'react'
import { useStore } from '../store'
import { runCommand } from '../lib/commands'

const EXAMPLES = ['xóa từ đệm', 'xóa khoảng lặng', 'cắt còn 45 giây', 'xuất dọc 9:16', 'lọc ồn']

/** GĐ6 — Chat-to-edit: ra lệnh chỉnh sửa bằng ngôn ngữ tự nhiên. */
export function ChatBar() {
  const hasClips = useStore((s) => s.clips.length > 0)
  const [text, setText] = useState('')
  const [reply, setReply] = useState('')

  const submit = () => {
    if (!text.trim()) return
    const msg = runCommand(text)
    setReply(msg)
    setText('')
  }

  if (!hasClips) return null

  return (
    <div className="chatbar">
      <span className="chat-icon">🤖</span>
      <input
        className="chat-input"
        placeholder='Ra lệnh: "xóa từ đệm", "xóa khoảng lặng", "cắt còn 60 giây"…'
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={(e) => e.key === 'Enter' && submit()}
      />
      <button className="btn small primary" onClick={submit}>
        Gửi
      </button>
      {reply ? (
        <span className="chat-reply">{reply}</span>
      ) : (
        <span className="chat-examples">
          Thử: {EXAMPLES.map((e) => (
            <button key={e} className="chat-eg" onClick={() => setText(e)}>
              {e}
            </button>
          ))}
        </span>
      )}
    </div>
  )
}
